import { DeleteModal, DeleteModalProps, Modal } from "@app/components/modals"
import { ModalInstance } from "@app/hooks/useModal"
import { IPaymentProvider } from "@app/common";

interface PaymentProviderDeleteModalProps extends ModalInstance<IPaymentProvider>, Omit<DeleteModalProps<IPaymentProvider>, 'children'> {
  onDelete: (paymentProvider: Partial<IPaymentProvider>) => void;
}

export const PaymentProviderDeleteModal = (props: PaymentProviderDeleteModalProps) => {
  return (
    <DeleteModal {...props} >
      <Modal.Subtitle>Vous allez supprimer une configuration de prestataire de paiement.</Modal.Subtitle>
      <Modal.Message>
        Cette suppression est irréversible.
      </Modal.Message>
    </DeleteModal>
  )
}